import { CorpType, Timezone } from '@fx-ui/platform-sdk';
import { LocaleRecord } from '~/interfaces';
import { CorpId } from '@libs/shared';

/**
 * 企业自定义登录页配置模式
 */
export enum CustomLoginConfigMode {
    // 配置模式
    config = 'config',
    // 预览模式
    preview = 'preview'
}

export interface ICorp {
    corp_id: CorpId;
    name: string;
    /** 企业创建者 Id */
    owner_id: string;
    type: CorpType;
}

export interface TimezoneInfo extends Timezone {
    /** eg: (GMT+8)Asia/Shanghai */
    text: LocaleRecord<string>;
}

/**
 * 接口 [列出角色↗](https://yapi.dev.jdydevelop.com/project/15/interface/api/538) 的 **返回类型**
 *
 * @请求头 `POST /corp/role/list`
 * @更新时间 `2020-12-21 19:42:02` vista
 */
export interface CorpRoleListResponse {
    /**
     * 角色列表
     */
    roles: {
        /**
         * 角色全局唯一 Id
         */
        _id: string;
        /**
         * 企业 Id
         */
        corp_id: string;
        /**
         * 角色 Id
         */
        role_id: number;
        /**
         * 角色组 Id
         */
        group_id?: number;
        /**
         * 角色名称
         */
        name: string;
        /**
         * 角色顺序
         */
        seq: string;
        /**
         * 角色类别
         */
        source: string;
        /**
         * 角色是否可编辑（相当于之前 /corp/role/list 中的 has_update_member 和 has_update_name）
         */
        editable: boolean;
    }[];
    /**
     * 角色组列表
     */
    role_groups: {
        /**
         * 角色组全局唯一 Id
         */
        _id: string;
        /**
         * 企业 Id
         */
        corp_id: string;
        /**
         * 角色组 Id
         */
        group_id: number;
        /**
         * 角色组名称
         */
        name: string;
        /**
         * 角色组顺序
         */
        seq: number;
        /**
         * 角色组类别
         */
        source: string;
    }[];
    /** 是否拥有全部角色写权限 */
    has_full_writable_permission: boolean;
    /** 是否拥有全部角色读权限 */
    has_full_readable_permission: boolean;
}

/**
 * 接口 [获取定时同步配置↗](https://yapi.dev.jdydevelop.com/project/15/interface/api/3716) 的 **返回类型**
 *
 * @请求头 `POST /corp/suite/get_cron_sync`
 * @更新时间 `2020-12-28 17:23:35` lizijun
 */
export interface CorpSuiteGetCronSyncResponse {
    /**
     * 是否开启同步状态
     */
    enable: boolean;
    /**
     * 上次同步时间
     */
    lastSyncTime?: string;
    /**
     * 同步状态
     * 0：成功
     * 1：失败
     * 2：同步中
     */
    syncStats?: 0 | 1 | 2;
    /**
     * 是否可以绑定 Cp 授权
     */
    has_cp_auth_update?: string;
    /**
     * 是否支持自动同步
     */
    has_auto_sync: boolean;
    /**
     * 是否绑定了CP参数
     */
    has_cp_auth?: boolean;
}

/**
 * 接口 [主客体企业信息概览↗](https://yapi.dev.jdydevelop.com/project/15/interface/api/5586) 的 **返回类型**
 *
 * @请求头 `POST /corp_coop/overview`
 * @更新时间 `2021-06-22 16:38:51` vista
 */
export interface CorpCoopOverviewResponse {
    has_corp_coop: boolean;
    corp_coop_quota: number;
    host_corp_list?: {
        corp_id?: string;
        name?: string;
    }[];
    guest_corp_list?: {
        corp_id?: string;
        name?: string;
        status?: number;
    }[];
}
